import ErrorScreen from '@shared/errorpages/ErrorScreen';
import { ErrorType } from '@util/enums';
import React from 'react';
import { useParams } from 'react-router-dom';
import { EntryLinksManager } from '../../features/entry-links/EntryLinksManager';
import { useAuth } from '../../providers/AuthProvider';
import AuditLogs from './audit/AuditLogs';
import InputSetup from './input/InputSetup';
import LocksManager from './managers/locks/LocksManager';
import UsersGroupsManager from './managers/usersgroups/UsersGroupsManager';
var routesConfigurationMap = {
    audit: { page: AuditLogs, featureKey: 'canSeeAuditLogs' },
    locks: { page: LocksManager, featureKey: 'canSeeYearVersionLocks' },
    'input-setup': { page: InputSetup, featureKey: 'canSeeInputSetup' },
    'users-groups': { page: UsersGroupsManager, featureKey: 'canSeeUsersGroupsManagement' },
    'entry-links': { page: EntryLinksManager, featureKey: 'canSeeEntryLinks' },
};
export default function AdminRouter() {
    var user = useAuth().user;
    var sectionName = useParams().sectionName;
    if (!user) {
        return null;
    }
    var route = routesConfigurationMap[sectionName !== null && sectionName !== void 0 ? sectionName : ''];
    if (!route) {
        return React.createElement(ErrorScreen, { type: ErrorType.NOT_FOUND });
    }
    if (route.featureKey && !user.features[route.featureKey]) {
        return React.createElement(ErrorScreen, { type: ErrorType.AUTH_ERR });
    }
    return React.createElement(route.page, null);
}
